var AngularSetup = require('../common/utils/angular-setup');

require('../common/branding/index.scss');
require("../common/index.scss");
require('./index.scss');

window.$ = window.jQuery = require('jquery');
window.Tether = require('tether');


var SetupAnalytics = require('../common/analytics');

var setup = module.exports = AngularSetup('applicant');

setup
.module(require('../common/deps').name)
.module(require("../common/applicant/ApplicationRegistrationQuestionsController").name)
.module(require('../common/directives').name)

setup.state('applicant', {
  abstract: true,
  url: '/applicant',
  template: require('./index.pug'),
  data: {
    authenticate: true,
    claims: [
      {type:"gdpr_questions_completed", value: null, redirect: '/account'},
      {type:"user_role", value:"applicant", redirect: '/'}
    ]
  }
})
.state('applicant.application', {
  url: '/application/:id',
  template: require('./create-application/index.pug'),
  controller: require('./create-application/'),
  controllerAs: 'vm'
})
.state('applicant.dashboard', {
  abstract: true,
  url: '/dashboard',
  template: require('./dashboard/index.pug')
})
.state('applicant.dashboard.organisation', {
  url: '',
  template: require('./dashboard/organisation/index.pug'),
  controller: require('./dashboard/organisation/'),
  controllerAs: 'vm'
})
.state('applicant.dashboard.reports', {
  url: '/reports',
  template: require('./dashboard/reports/index.pug'),
  controller: require('./dashboard/reports/'),
  controllerAs: 'vm'
})
.state('applicant.dashboard.projects', {
  url: '/projects',
  template: require('./dashboard/projects/index.pug'),
  controller: require('./dashboard/projects/'),
  controllerAs: 'vm'
})
.state('applicant.dashboard.applications', {
  url: '/applications',
  template: require('./dashboard/applications/index.pug'),
  controller: require('./dashboard/applications/'),
  controllerAs: 'vm'
})
.state('applicant.dashboard.projects.project', {
  url: '/:id',
  template: require('./dashboard/projects/project/index.pug'),
  controller: require('./dashboard/projects/project/'),
  controllerAs: 'vm'
})
.state('applicant.dashboard.applications.application', {
  url: '/:id',
  template: require('./dashboard/applications/application/index.pug'),
  controller: require('./dashboard/applications/application/'),
  controllerAs: 'vm'
})
.state('applicant.dashboard.applications.apply', {
  url: '/:id/apply',
  template: require('./dashboard/applications/application/apply/index.pug'),
  controller: require('./dashboard/applications/application/apply/'),
  controllerAs: 'vm'
})
.state('applicant.dashboard.fundraisingoffer', {
  url: '/fundraisingoffer/:id',
  template: require('./dashboard/fundraisingoffer/index.pug'),
  controller: require('./dashboard/fundraisingoffer/'),
  controllerAs: 'vm'
})
.state('applicant.dashboard.applications.profile', {
  url: '/:id/profile',
  template: require('./dashboard/applications/application/profile/index.pug'),
  controller: require('./dashboard/applications/application/profile/'),
  controllerAs: 'vm'
})

setup.auth(require('./auth'));

// init app module
var app = setup.done();

SetupAnalytics(app);

app.filter('ordinalSuffix', function(){
 var suffixes = ["th", "st", "nd", "rd"];
  return function(day) {
    var relevantDigits = (day < 30) ? day % 20 : day % 30;
    var suffix = (relevantDigits <= 3) ? suffixes[relevantDigits] : suffixes[0];
    return day+suffix;
  };

})


app.filter('weekdayFilter', function(){
  return function(day) {
    var wd = '';
    switch(day) {
        case 1:
            wd = 'Monday';
            break;
        case 2:
            wd = 'Tuesday';
            break;
        case 3:
            wd = 'Wednesday';
            break;
        case 4:
            wd = 'Thursday';
            break;
        default:
            wd = 'Friday';
    }
    return wd;
  }
})

app.filter('formatValueByType', function(currencyFilter){
  return function(input, type) {
    if (isCurrencyType(type)) {
      return currencyFilter(input, "£", 0);
    }
    return input;
  }

  function isCurrencyType(type) {
    return !!(/currency/i).exec(type);
  }
})

app.filter('yesNo', function(){
  return function(boolIn){
    return boolIn ? "Yes" : "No";
  }
})
